import { FC, useMemo } from 'react';
import { UserScenarioLearnablesResponse } from 'src/api/userScenario/types';
import { defineMessages, useIntl } from 'react-intl';
import * as S from 'src/apps/LearningSession/EndOfSession/ScenarioSummary/styles';

const msgs = defineMessages({
  title: { id: 'eos_learn_scenarioSummary_title' },
  wordCount: { id: 'eos_learn_scenarioSummary_wordCount_web' },
  notStarted: { id: 'eos_learn_scenarioSummary_notStarted' },
  started: { id: 'eos_learn_scenarioSummary_startedLearning' },
  fullyLearned: { id: 'eos_learn_scenarioSummary_fullyLearned' },
});

export const calculateScenarioSummary = ({ learnables }: UserScenarioLearnablesResponse) => {
  const notAlreadyKnown = learnables.filter(l => !l.alreadyKnown);

  return {
    notStarted: notAlreadyKnown.filter(l => l.growthLevel === 0).length,
    started: notAlreadyKnown.filter(l => l.growthLevel > 0 && l.growthLevel < 6).length,
    learned: notAlreadyKnown.filter(l => l.growthLevel >= 6).length,
    alreadyKnown: learnables.filter(l => l.alreadyKnown).length,
  };
};

export const ScenarioSummary: FC<{ scenario: UserScenarioLearnablesResponse }> = ({ scenario }) => {
  const intl = useIntl();
  const summary = useMemo(() => calculateScenarioSummary(scenario), [scenario]);

  return (
    <S.SummaryContainer>
      <S.DescriptionSection>
        <S.Title>{intl.formatMessage(msgs.title)}</S.Title>
        <S.Description>
          {intl.formatMessage(msgs.wordCount, {
            wordCount: scenario.numberOfLearnables,
          })}
        </S.Description>
      </S.DescriptionSection>
      <S.SummarySection>
        <S.GrowthLevelIndicator growthLevel={6} />
        <S.SummaryText>{intl.formatMessage(msgs.fullyLearned)}</S.SummaryText>
        <S.SummaryNumber>{summary.learned + summary.alreadyKnown}</S.SummaryNumber>
      </S.SummarySection>
      <S.SummarySection>
        <S.GrowthLevelIndicator growthLevel={3} />
        <S.SummaryText>{intl.formatMessage(msgs.started)}</S.SummaryText>
        <S.SummaryNumber>{summary.started}</S.SummaryNumber>
      </S.SummarySection>
      <S.SummarySection>
        <S.GrowthLevelIndicator growthLevel={0} />
        <S.SummaryText>{intl.formatMessage(msgs.notStarted)}</S.SummaryText>
        <S.SummaryNumber>{summary.notStarted}</S.SummaryNumber>
      </S.SummarySection>
    </S.SummaryContainer>
  );
};
